<template lang="pug">
.content
    setting-title(
        title="转化目标设置",
    )
        div#backToReport 完成本页操作后可
            router-link(to="/web/overview") 查看分析
    .zone.content-part
        domain-select(extra="为网站$domain设置转化目标", @change="onDomainChange")
            span(slot="front") (为网站
            span(slot="back") 设置转化目标)
    .zone.content-part.paddingbt30.iframe-header
        TableTitle(slot="icon", icon="fa fa-list", title="转化目标设置列表")
        hr.header-chart-line.no-margin
        ul.tab.trans-tab
          li.tab-item(v-for="item in tablist")
            .tab-item-btn(:class="{ active : currentTab == item.id}",
              @click.prevent= "changeTabTo(item.id)")
              | {{item.title}}
        div(v-if="currentTab == 'system'")
          table.data-table(style="table-layout:fixed;margin-top:15px;")
            thead
              tr
                th(width="30%") 转化类型细分
                th(width="40%") 转化统计指标
                th(width="30%") 操作
            tbody
              tr(v-for="item in systemList")
                td {{item.typedetail}}
                td {{item.indice}}
                td 
                  a(@click.prevent="gotoCodePage(item.type)") 获取{{item.typedetail}}回传代码


        div(v-else-if="currentTab == 'custom'")
          .toolbar-row
            v-select(
                v-model="selectedType",
                @input="changeListPage(1)",
                :options="transtypeSelectList"
              )
            .btn.btn-primary.btn-big(@click="openAddTransInfo") 添加转化目标
          table.data-table(style="table-layout: fixed;")
              thead
                  tr
                      th(width="35%") 转化目标名称
                      th(width="15%") 转化类型
                      th(width="15%") 转化类型细分
                      th(width="20%") 创建时间
                      th(width="15%") 操作
              tbody
                  tr(v-if="isLoading")
                      td(colspan="5", style="text-align: center;") 
                        img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif")
                  tr(v-else-if="isListEmpty")
                      td.noresult(colspan="5") 请先添加转化目标，然后查看转化效果分析
                  tr(v-for="(item, index) in list", v-else-if="!isListEmpty")
                      td {{item.name}}
                      td {{item.type | transTypeFilter}}
                      td {{item | transTypeDetailFilter}}
                      td {{item.createtime}}
                      td
                          i.fa.fa-eye.fa-lg(title="查看", @click="showDetail(item, index)", :style="{marginRight: '8px'}")
                          i.fa.fa-pencil-square-o.fa-lg(title="修改", @click="editTransInfo(item, index)", :style="{marginRight: '8px'}")
                          i.fa.fa-trash-o.fa-lg(title="删除", @click="deleteListItem(item, index)")
          v-pagination(:total="total", :pn="pageNum", ps="20", @updatepage="changeListPage" v-show="total > 20")
          .note-text （注：设置转化目标前，请确保基础代码已安装并生效）

    v-modal(:visible="transInfoVisible",
                  :title="transInfoTitle",
                  ref="formModal",
                  @closemodal="closeModal")
        .modal-bd(v-if="transInfoDel")
          p.content-part 确定删除么
          .btn-wrap
              button.btn.btn-primary.btn-small(@click="delTransInfo") 确定
              button.btn.btn-default.btn-small(@click="closeModal") 取消
        .modal-bd(v-else-if="!transInfoEdit")
            .modal-content
               v-form(v-model="transInfo")
                 .item
                     .label 转化类型：
                     .control {{transInfo.type | transTypeFilter}}
                 .item
                     .label 转化类型细分：
                     .control {{transInfo | transTypeDetailFilter}}
                 .item
                     .label 转化目标名称：
                     .control {{transInfo.name}}
                 .trans-content(v-if="transtype ==='1'")
                   .item
                     .label 目标网页URL：
                     .control {{transInfo.url}}
                   .item
                     .label 高级设置： 
                     .control
                          table.data-table(v-show="transInfo.route && transInfo.route.length > 0")
                             thead
                                 tr
                                     th 序号
                                     th URL
                             tbody
                                 tr(v-for="(trans, index) in transInfo.route ")
                                     td {{index + 1}}
                                     td(:title="trans.url") {{trans.url}}
                   .item
                       .label 预期收益：
                       .control {{transInfo.income}} 元
                   .item(v-if="transInfo.rtstrict == '1'")
                       .label 
                       .control 只有经过路径的目标才记为转化 （访问路径不包括目标网页URL）
                 .trans-content(v-if="transtype ==='2'")
                     .item
                         .label 事件ID：
                         .control {{transInfo.eventid}}
                     .item
                         .label 事件页面URL：
                         .control {{transInfo.url}}
                     .item
                         .label 预期收益：
                         .control {{transInfo.income}} 元
                 .trans-content(v-if="transtype ==='3'")
                     .item
                         .label 页面URL：
                         .control {{transInfo.url}}
                     .item
                         .label 平均访问时长：
                         .control 大于 {{transInfo.minutes}} 分 {{transInfo.seconds}} 秒
                     .item
                         .label 预期收益：
                         .control {{transInfo.income}} 元
                 .trans-content(v-if="transtype ==='4'")
                     .item
                         .label 平均访问页数：
                         .control 大于 {{transInfo.accpage}} 页
                     .item
                         .label 预期收益：
                         .control {{transInfo.income}} 元
        .modal-bd(v-else-if="transInfoEdit")
            .modal-content
                v-form(v-model="transInfo",
                  :before-submit="beforeSubmit",
                  ref="transform")
                    .item
                        .label 转化类型：
                        .control
                            v-radio-group(name="transtype" v-model="transtype", :options="transtypeList", @change.native="errmsgShow = false")
                    .item(v-if="transtype == 1 || transtype == 2")
                        .label 转化类型细分：
                        .control
                            v-radio-group(name="transDetail" v-model="transInfo.type_d", :options="transDetailList", @change.native="errmsgShow = false" required)
                            v-input.size-small(
                              name="remark",
                              v-model="transInfo.remark",
                              :placeholder="otherDetailPlaceholder",
                              :rules="rules.otherDetail",
                              :disabled="transInfo.type_d !== '4'")
                            em.error(v-show="errmsgShow") 请输入转化细分
                    .item
                        .label 转化目标名称：
                        .control
                            v-input(v-model="transInfo.name", :rules="rules.title" placeholder="请输入1-10字符名称")
                    .trans-content(v-show="transtype ==='1'")
                      .item
                          .label 目标网页URL：
                          .control
                            v-input(v-model="transInfo.url", :rules="rules.url" placeholder="请输入URL如：http://aaa.com，可通配")
                            v-tooltip(tip="若您想监测某注册完成页http://www.aaa.com/sign_up/id=xxx，不同访客有不同id，则目标页面可设置为http://www.aaa.com/sign_up/id=*；若您想监测某页面不同渠道的流量来源数据，可将该目标页面设置为http://www.aaa.com/*" pos="right")
                              i.fa.fa-question-circle
                      .item
                          .label 预期收益：
                          .control
                            v-input(v-model="transInfo.income", :rules="rules.income" placeholder="请输入数字")
                            | 元
                      .item
                        .label 高级设置：
                        .control
                          .btn(:class="addTransUrlClass",v-show="transUrlList.length < 5", @click="addTransUrl") 添加经过URL
                          table.data-table.convert-path(v-show="transUrlList.length > 0")
                              thead
                                  tr
                                      th 序号
                                      th URL
                                      th 操作
                              tbody
                                  tr(v-for="(trans , index) in transUrlList ")
                                      td {{index + 1}}
                                      td(:title="trans.url" v-if="trans.url != ''") {{trans.url}}
                                      td( v-if="trans.url == ''") 
                                          v-input(v-model="transInfoURL", :rules="rules.url", ref="processurl", placeholder="请输入URL如：http://aaa.com，可通配")
                                      td( v-if="trans.url == ''")
                                          button.btn.btn-primary.btn-small(@click.prevent="saveTransUrl") 保存
                                          button.btn.btn-default.btn-small(@click.prevent="delcurrentTransUrl(index)") 删除
                                      td( v-if="trans.url != ''")
                                          button.btn.btn-default.btn-small(@click.prevent="delTransUrl(index)") 删除
                      .item(v-show="transUrlList.length > 0")
                        .label 
                        .control 
                          v-checkbox(v-model="transInfo.rtstrict") 
                          | 只有按顺序经过以上URL目标才算转化（该URL不可与目标网页URL相同）
                      .item(v-show="transUrlList.length > 0")
                        .label 
                        .control
                          p 
                            | 说明：URL设置中均可使用通配符*通配 
                            v-tooltip(tip="若您想监测某注册完成页http://www.aaa.com/sign_up/id=xxx，不同访客有不同id，则目标页面可设置为http://www.aaa.com/sign_up/id=*；若您想监测某页面不同渠道的流量来源数据，可将该目标页面设置为http://www.aaa.com/*" pos="right")
                              i.fa.fa-question-circle
                    .trans-content(v-if="transtype ==='2'")
                      .item
                        .label 事件ID：
                        .control
                            v-input(v-model="transInfo.eventid", placeholder="请直接输入ID内容", :rules="rules.eventid")
                            a.btn.btn-icon.btn-primary(target="_blank" href="https://fenxi.360.cn/help/manual?target=conversion") 如何获取？
                      .item
                        .label 事件页面URL：
                        .control
                            v-input(v-model="transInfo.url", :rules="rules.url" placeholder="请输入URL如：http://aaa.com，可通配")
                            v-tooltip(tip="若您想监测某注册完成页http://www.aaa.com/sign_up/id=xxx，不同访客有不同id，则目标页面可设置为http://www.aaa.com/sign_up/id=*；若您想监测某页面不同渠道的流量来源数据，可将该目标页面设置为http://www.aaa.com/*" pos="right")
                              i.fa.fa-question-circle
                      .item
                        .label 预期收益：
                        .control
                            v-input(v-model="transInfo.income", :rules="rules.income" placeholder="请输入数字")
                            | 元

                    .trans-content(v-if="transtype ==='3'")
                      .item
                        .label 页面URL：
                        .control
                            v-input(v-model="transInfo.url", :rules="rules.url" placeholder="请输入URL如：http://aaa.com，可通配")
                            v-tooltip(tip="添加页面URL则统计访客在该页面访问时长，不添加则统计访客每次访问的平均时长" pos="right")
                              i.fa.fa-question-circle
                      .item
                        .label 平均访问时长：
                        .control.ml5
                            | 大于
                            v-input.size-small(v-model="transInfo.minutes" @input.native="hideErrmsg")
                            | 分
                            v-input.size-small(v-model="transInfo.seconds" @input.native="hideErrmsg")
                            | 秒
                            em.error(v-show="errmsgShow") 请输入平均访问时长
                      .item
                        .label 预期收益：
                        .control
                            v-input(v-model="transInfo.income", :rules="rules.income" placeholder="请输入数字")
                            | 元

                    .trans-content(v-if="transtype ==='4'")
                      .item
                        .label 平均访问页数：
                        .control.ml5
                            | 大于
                            select(v-model="transInfo.accpage" @change="hideErrmsg" class="size-small")
                                option(v-for="page in pagesList", :value="page") {{page}}
                            | 页
                            em.error(v-if="errmsgShow") 请选择页数
                      .item
                        .label 预期收益：
                        .control
                            v-input(v-model="transInfo.income", :rules="rules.income" placeholder="请输入数字")
                            | 元
                    .btn-wrap
                        button.btn.btn-primary.btn-small(type="submit") 确认
                        button.btn.btn-default.btn-small(@click="closeModal") 取消
</template>
<script>
/* global _ */
function generateDuration () {
  const list = []
  let i = 1
  list.push('请选择')
  while (i <= 10) {
    list.push(i)
    i++
  }
  list.push(20)
  list.push(25)
  list.push(30)
  return list
}

export default {
  data () {
    return {
      domainId: 0,
      pageNum: 1,
      total: 0,
      isLoading: false,
      list: [],
      errmsgShow: false,
      transInfoDel: false,
      transInfoEdit: false,
      transInfoVisible: false,
      transInfoTitle: '',
      selectedType: 0,
      currentTab: 'custom',
      tablist: [
        {
          id: 'custom',
          title: '自定义转化指标'
        }, {
          id: 'system',
          title: '系统转化指标'
        }
      ],
      systemList: [
        {
          typedetail: '订单',
          type: 'order',
          indice: '订单量、订单转化率、订单金额'
        }, {
          typedetail: '注册',
          type: 'register',
          indice: '注册量、注册转化率'
        }
      ],
      transtypeList: [
        {
          value: 1,
          title: '页面转化',
          label: '页面转化'
        }, {
          value: 2,
          title: '事件转化',
          label: '事件转化'
        }, {
          value: 3,
          title: '时长转化',
          label: '时长转化'
        }, {
          value: 4,
          title: '页数转化',
          label: '页数转化'
        }
      ],
      transtype: '1',
      defaultTransInfo: {
        name: '',
        url: '',
        type: 1,
        type_d: '0',
        remark: '',
        accpage: '请选择',
        acctime: 0,
        income: 0,
        eventid: null,
        route: [],
        rtstrict: false,
        minutes: '00',
        seconds: 0
      },
      transInfo: {},
      transInfoURL: '',
      transUrlList: [],
      transUrl: '',
      pages: '请选择',
      pagesList: generateDuration(),
      urlAddable: true,
      api: ''
    }
  },
  filters: {
    transTypeDetailFilter (item) {
      const typeDetail = ['--', '订单', '注册', '咨询', '其他', '创建角色', '扫码', '留咨']
      const remark = Number(item.type_d) === 4 ? ` - ${item.remark ? item.remark : ''}` : ''
      return typeDetail[item.type_d] + remark
    }
  },
  computed: {
    transDetailList () {
      const detailList = [
        {
          value: 1,
          title: '订单',
          lable: '订单'
        }, {
          value: 2,
          title: '注册',
          label: '注册'
        }, {
          value: 3,
          title: '咨询',
          label: '咨询'
        },
        {
          value: 5,
          title: '创建角色',
          label: '创建角色'
        },
        {
          value: 6,
          title: '扫码',
          label: '扫码'
        },
        {
          value: 7,
          title: '留咨',
          label: '留咨'
        },
        {
          value: 4,
          title: '其他',
          label: '其他'
        }
      ].filter(item => {
        return (Number(this.transtype) === 1 && (item.value === 1 || item.value === 2 || item.value === 4)) || Number(this.transtype) !== 1
      })
      return detailList
    },
    otherDetailPlaceholder () {
      return '请输入1-20字符'
    },
    transtypeSelectList () {
      return _.concat([
        {
          value: 0,
          label: '全部转化'
        }
      ], this.transtypeList)
    },
    uiError () {
      return this.$store.state.uiError
    },
    addTransUrlClass () {
      return this.urlAddable ? ['btn-primary', 'btn-icon'] : 'gray'
    },
    isListEmpty () {
      return !this.list || !this.list.length
    },
    rules () {
      const url = {
        pattern: /^https?:\/\/[a-zA-Z0-9][a-zA-Z0-9-]*\.[a-zA-Z0-9]+[^\s]*\s*$/,
        maxlength: 600,
        msg: {
          required: '请填写URL'
        }
      }
      if (this.transtype === '1' || this.transtype === '2') {
        this.$set(url, 'required', true)
      }
      const rules = {
        otherDetail: {
          maxlength: 20
        },
        title: {
          required: true,
          maxlength: 10
        },
        income: {
          pattern: /^(?:(?:[1-9]\d{0,3}(?:\.\d{1,2})?)|(?:[0](\.\d{1,2})?)|(?:[1-9]\d{0,5}))$/,
          msg: {
            pattern: '最多输入6位数字'
          }
        },
        eventid: {
          maxlength: 100
        },
        acctime: {
          required: true,
          type: 'number'
        }
      }
      this.$set(rules, 'url', url)
      return rules
    }
  },
  watch: {
    uiError () {
      this.$Modal.warn(this.uiError.errMsg)
      this.closeModal()
    }
  },
  methods: {
    gotoCodePage (codeType) {
      this.$store.commit('SET_CROSS_PARAM', {
        codeType: codeType
      })
      this.$router.push('/setting/gencode')
    },
    changeTabTo (tab) {
      this.currentTab = tab
    },
    hideErrmsg () {
      this.errmsgShow = false
    },
    beforeSubmit () {
      const acctime = parseInt(this.transInfo.minutes, 10) * 60 + parseInt(this.transInfo.seconds)
      const isPageUnvalid = (Number(this.transtype) === 4 && this.transInfo.accpage === '请选择')
      const isTimeUnvalid = (Number(this.transtype) === 3 && acctime === 0)
      const isDetailUnvalid = (Number(this.transtype) === 2 || Number(this.transtype) === 1) &&
        (Number(this.transInfo.type_d) === 0 ||
        (Number(this.transInfo.type_d) === 4 &&
        (this.transInfo.remark.length < 1 || this.transInfo.remark.length > 20)))
      if (isPageUnvalid || isTimeUnvalid || isDetailUnvalid) {
        this.errmsgShow = true
        return false
      }
      const params = {
        domainId: this.$store.state.domainId,
        name: this.transInfo.name.trim(),
        type: this.transtype,
        url: this.transInfo.url.trim(),
        income: this.transInfo.income,
        type_d: this.transInfo.type_d,
        remark: this.transInfo.remark,
        rtstrict: this.transInfo.rtstrict ? 1 : 0,
        acctime: acctime,
        accthan: 1,
        eventid: this.transInfo.eventid,
        route: JSON.stringify(this.transUrlList)
      }
      if (this.transtype === '4') {
        params.accpage = this.transInfo.accpage
      }
      if (!this.transInfoAdd) {
        params.id = this.transInfo.id
      }
      const transInfoPromise = this.$http.get(this.api, {params: params})
      this.$store.dispatch('VUE_HTTP', [transInfoPromise])
        .then((res) => {
          if (res && !res.errno) {
            this.onDomainChange()
            this.closeModal()
          }
        })
      return false
    },
    delTransInfo () {
      const infoDelPromise = this.$http.get('/api/trans/delete', {params: {
        domainId: this.$store.state.domainId,
        id: this.transInfo.id
      }})
      this.$store.dispatch('VUE_HTTP', [infoDelPromise])
        .then((res) => {
          if (res) {
            this.closeModal()
            this.onDomainChange()
          }
        })
    },
    closeModal () {
      this.transInfo = _.cloneDeep(this.defaultTransInfo)
      this.transtype = '1'
      this.$set(this, 'transUrlList', [])
      this.$refs.transform && this.$refs.transform.resetValidity()
      this.transInfoURL = ''
      this.urlAddable = true
      this.transInfoEdit = false
      this.transInfoDel = false
      this.transInfoAdd = false
      this.timeCustom = false
      this.transInfoVisible = false
    },
    openAddTransInfo () {
      this.transInfoTitle = '添加转化目标'
      this.api = '/api/trans/add'
      this.transInfo = _.cloneDeep(this.defaultTransInfo)
      this.transInfoEdit = true
      this.transInfoVisible = true
      this.transInfoAdd = true
      this.errmsgShow = false
    },
    getDetailInfo (item, index) {
      const params = {
        id: item.id,
        domainId: this.$store.state.domainId
      }
      const transDetailPromise = this.$http.get('/api/trans/get', {params: params})
      this.$store.dispatch('VUE_HTTP', [transDetailPromise])
        .then((res) => {
          if (res) {
            res.data.route = JSON.parse(res.data.route)
            res.data.rtstrict = res.data.rtstrict !== '0'
            res.data.minutes = Math.floor(res.data.acctime / 60)
            res.data.seconds = res.data.acctime % 60
            res.data.accpage = parseInt(res.data.accpage, 10) ? parseInt(res.data.accpage, 10) : '请选择'
            this.transUrlList = res.data.route || []
            this.transInfo = res.data
            this.transtype = res.data.type
            this.transInfoVisible = true
          }
        })
    },
    showDetail (item, index) {
      this.transInfoTitle = '转化目标详情'
      this.getDetailInfo(item, index)
    },
    editTransInfo (item, index) {
      this.transInfoTitle = '编辑转化目标'
      this.api = '/api/trans/edit'
      this.getDetailInfo(item, index)
      this.errmsgShow = false
      this.transInfoEdit = true
    },
    addTransUrl () {
      if (this.urlAddable) {
        const newTransUrl = {
          name: '',
          url: ''
        }
        this.transUrlList.push(newTransUrl)
        // modal 垂直居中
        const modalRef = this.$refs.formModal
        const centerFn = modalRef._centerModal
        this.$nextTick(() => centerFn && modalRef._centerModal())
        this.urlAddable = false
      }
    },
    delTransUrl (index) {
      this.transUrlList.splice(index, 1)
    },
    saveTransUrl () {
      this.$refs.processurl[0].validate()
      if (this.$refs.processurl[0].validity.valid && !_.isEmpty(this.transInfoURL.trim())) {
        this.$set(this.transUrlList[this.transUrlList.length - 1], 'url', this.transInfoURL)
        this.transInfoURL = ''
        this.urlAddable = true
      }
    },
    delcurrentTransUrl () {
      this.transUrlList.pop()
      this.transInfoURL = ''
      this.urlAddable = true
    },
    deleteListItem (item, index) {
      this.transInfoTitle = '删除转化目标'
      this.transInfo = item
      this.transInfoVisible = true
      this.transInfoDel = true
    },
    requestList () {
      this.isLoading = true
      const listPromise = this.$http.get('/api/trans/list', {params: {
        domainId: this.$store.state.domainId,
        type: this.selectedType,
        pg: this.pageNum,
        ps: 20
      }})
      this.$store.dispatch('VUE_HTTP', [listPromise])
        .then((res) => {
          if (res) {
            this.isLoading = false
            this.list = res.list
            this.total = res.total
          }
        })
    },
    changeListPage (num) {
      this.pageNum = num
      this.requestList()
    },
    onDomainChange () {
      this.pageNum = 1
      this.requestList()
    }
  }
}
</script>

<style scoped>
.trans-tab:hover {
  background: #fff;
}
.trans-tab .tab-item {
  display: block;
  margin-top: 10px;
}
.trans-tab .tab-item-btn {
  padding: 0 15px;
}
.trans-tab .active {
  border-bottom: 2px solid #56bf8b;
}
.content-part{ overflow: visible;}
.fa {
  cursor: pointer;
}
.toolbar-row {
    margin: 10px;
}
.modal .modal-bd {
  width: 900px;
}
.form .label {
  width: 20%;
}
.form .control {
  width: 80%;
  float: left;
  word-wrap: break-word;
  .size-small {
    margin-left: 5px;
  }
}
.form .data-table {
  line-height: 1;
}
.modal .modal-bd .btn-wrap{
  background: #fff;
  text-align: center;
}
.gray {
  color: #666;
}
.modal .data-table td {
  max-width: 300px;
  position: relative;
  overflow: visible;
}
.addurl {
  font-family: Helvetica, 'Microsoft Yahei', sans-serif;
  font-size: 12px
}
.input-wrap,
.ml5 {
  padding-left: 5px;
}

.toolbar-row select {
    vertical-align: middle;
}
.note-text {
  margin-top: 15px;
  padding: 0 15px;
  font-size: 12px;
  color: #a3b1bf;
}
.zone.iframe-header{
  padding: 0;
  header {
    margin: 10px 20px;
  }
}
.zone.paddingbt30 {
  padding-bottom: 30px;
}
.no-margin {
  margin: 0;
}
.trans-tab {
  margin: 0 15px;
}

</style>



// WEBPACK FOOTER //
// trans.vue?700f628d